/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: ooL7EhXDmFQWnW9sxtchhE
// Component: B2dxgzfI6E

import * as React from "react";

import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  Flex as Flex__,
  hasVariant,
  renderPlasmicSlot,
  SingleBooleanChoiceArg,
  StrictProps,
  useDollarState,
  useTrigger,
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";

import { _useGlobalVariants } from "./plasmic"; // plasmic-import: ooL7EhXDmFQWnW9sxtchhE/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: ooL7EhXDmFQWnW9sxtchhE/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import "../PP__plasmickit_dashboard.css"; // plasmic-import: ooL7EhXDmFQWnW9sxtchhE/projectcss
import sty from "./PlasmicDataSource.module.css"; // plasmic-import: B2dxgzfI6E/css

import PencilSvgIcon from "../plasmic_kit_icons/icons/PlasmicIcon__PencilSvg"; // plasmic-import: 540duoJvb/icon

createPlasmicElementProxy;

export type PlasmicDataSource__VariantMembers = {
  readOnly: "readOnly";
};
export type PlasmicDataSource__VariantsArgs = {
  readOnly?: SingleBooleanChoiceArg<"readOnly">;
};
type VariantPropType = keyof PlasmicDataSource__VariantsArgs;
export const PlasmicDataSource__VariantProps = new Array<VariantPropType>(
  "readOnly"
);

export type PlasmicDataSource__ArgsType = {
  children?: React.ReactNode;
  menuButton?: React.ReactNode;
};
type ArgPropType = keyof PlasmicDataSource__ArgsType;
export const PlasmicDataSource__ArgProps = new Array<ArgPropType>(
  "children",
  "menuButton"
);

export type PlasmicDataSource__OverridesType = {
  root?: Flex__<"div">;
  svg?: Flex__<"svg">;
};

export interface DefaultDataSourceProps {
  children?: React.ReactNode;
  menuButton?: React.ReactNode;
  readOnly?: SingleBooleanChoiceArg<"readOnly">;
  className?: string;
}

const $$ = {};

function PlasmicDataSource__RenderFunc(props: {
  variants: PlasmicDataSource__VariantsArgs;
  args: PlasmicDataSource__ArgsType;
  overrides: PlasmicDataSource__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants,
  };

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "readOnly",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.readOnly,
      },
    ],
    [$props, $ctx, $refs]
  );

  const globalVariants = _useGlobalVariants();

  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs,
  });

  const [isRootHover, triggerRootHoverProps] = useTrigger("useHover", {});
  const [isRootFocusWithin, triggerRootFocusWithinProps] = useTrigger(
    "useFocusedWithin",
    {}
  );
  const triggers = {
    hover_root: isRootHover,
    focusWithin_root: isRootFocusWithin,
  };

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_ooL7EhXDmFQWnW9sxtchhE",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root,
        { [sty.rootreadOnly]: hasVariant($state, "readOnly", "readOnly") }
      )}
      data-plasmic-trigger-props={[
        triggerRootHoverProps,
        triggerRootFocusWithinProps,
      ]}
    >
      <div
        className={classNames("all", sty.freeBox__vUr6W, {
          [sty.freeBoxreadOnly__vUr6WxkCNh]: hasVariant(
            $state,
            "readOnly",
            "readOnly"
          ),
        })}
      >
        {renderPlasmicSlot({
          defaultContents: "Data source name",
          value: args.children,
        })}
      </div>
      <div className={classNames("all", sty.freeBox__fgqCy)}>
        <PencilSvgIcon
          data-plasmic-name={"svg"}
          data-plasmic-override={overrides.svg}
          className={classNames("all", sty.svg, {
            [sty.svgreadOnly]: hasVariant($state, "readOnly", "readOnly"),
          })}
          role={"img"}
        />

        {renderPlasmicSlot({
          defaultContents: null,
          value: args.menuButton,
        })}
      </div>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "svg"],
  svg: ["svg"],
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  svg: "svg";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicDataSource__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicDataSource__VariantsArgs;
    args?: PlasmicDataSource__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicDataSource__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    // Specify args directly as props
    Omit<PlasmicDataSource__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicDataSource__ArgProps,
          internalVariantPropNames: PlasmicDataSource__VariantProps,
        }),
      [props, nodeName]
    );
    return PlasmicDataSource__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName,
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicDataSource";
  } else {
    func.displayName = `PlasmicDataSource.${nodeName}`;
  }
  return func;
}

export const PlasmicDataSource = Object.assign(
  // Top-level PlasmicDataSource renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    svg: makeNodeComponent("svg"),

    // Metadata about props expected for PlasmicDataSource
    internalVariantProps: PlasmicDataSource__VariantProps,
    internalArgProps: PlasmicDataSource__ArgProps,
  }
);

export default PlasmicDataSource;
/* prettier-ignore-end */
